import type { Album } from "./types"
import { translations } from "../../translations"
import { useTranslationUpdate } from "../../hooks/useTranslationUpdate"
import styles from "./GalleryWindow.module.css"

type Props = {
  albums: Album[]
  onAlbumClick: (album: Album) => void
}

export default function AlbumsGrid({ albums, onAlbumClick }: Props) {
  useTranslationUpdate()
  return (
    <div className={styles.albumGrid}>
      {albums.map((album) => {
        const cover = album.photos?.[album.coverIndex ?? 0] || album.photos?.[0]
        return (
          <button
            key={album.id}
            className={styles.albumCard}
            onClick={() => onAlbumClick(album)}
          >
            <div className={styles.albumCover}>
              {cover && (
                <img 
                  src={cover.src} 
                  alt={album.name} 
                  className={styles.albumImg} 
                  loading="lazy" 
                  decoding="async" 
                  draggable={false} 
                />
              )}
            </div>
            <div className={styles.albumInfo}>
              <div className={styles.albumName}>{translations(album.name)}</div>
              <div className={styles.albumCount}>{album.photos?.length || 0}</div>
            </div>
          </button>
        )
      })}
    </div>
  )
}
